"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
var AlertTitle_1 = __importDefault(require("@material-ui/lab/AlertTitle"));
var Alert = react_1.forwardRef(function Alert(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'standard' : _b, title = _a.title, _c = _a.severity, severity = _c === void 0 ? 'info' : _c, onClose = _a.onClose, children = _a.children, rest = __rest(_a, ["variant", "title", "severity", "onClose", "children"]);
    return (jsx_runtime_1.jsxs(Alert_1.default, __assign({ severity: severity, variant: variant, onClose: onClose }, rest, { ref: ref }, { children: [title && jsx_runtime_1.jsx(AlertTitle_1.default, { children: title }, void 0), children] }), void 0));
});
exports.default = Alert;
//# sourceMappingURL=Alert.js.map